import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface RadarChartUniDriver extends BaseUniDriver {
  getScaleLinesCount(): Promise<number>;
}
